import React, { Fragment } from "react";
import SectionTitle from "../common/section_title";
import MentorBox from "../common/mentor_box";
import styles from "./styles/home.module.scss";
import { getAssets } from "@unisearch/helpers";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const img_01 = getAssets("assets/images/avatar-01.png");
const logo_01 = getAssets("assets/images/logo/logo-01.png");
const logo_02 = getAssets("assets/images/logo/logo-02.png");

export const Mentors = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const data = {
    mentor_image: img_01,
    mentor_logo1: logo_01,
    mentor_logo2: logo_02,
    mentor_name: "Shifa Soomar",
  };

  return (
    <Fragment>
      <section className={styles.upcoming_events}>
        <div className="container">
          <SectionTitle
            shadow_text="YOUR GUIDANCE TO CONNECT WITH MENTORS"
            title="Mentors"
          >
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled{" "}
            </p>
          </SectionTitle>
        </div>

        <div className={styles.event_container}>
          <Slider {...settings}>
            <div>
              <MentorBox data={data} />
            </div>
            <div>
              <MentorBox data={data} />
            </div>
            <div>
              <MentorBox data={data} />
            </div>
            <div>
              <MentorBox data={data} />
            </div>
            <div>
              <MentorBox data={data} />
            </div>
            <div>
              <MentorBox data={data} />
            </div>
            <div>
              <MentorBox data={data} />
            </div>
            <div>
              <MentorBox data={data} />
            </div>
          </Slider>
        </div>

        <div className="text-center">
          <button className="btn_primary mb-3">View All 2500+ Mentors</button>
        </div>
      </section>
    </Fragment>
  );
};
export default Mentors;
